<template>

    <div class="page-static-container">

        <header-static v-if="!isNativeUser"></header-static>

        <article v-if="isFrench" class="page-static-text-container">


            <section class="press__section">

                <h1 class="cfsp-title-1 press__title">Presse</h1>

                <h2 class="cfsp-title-2">Vous voulez parler de Cleanfox ?</h2>

            </section>


            <div class="press__container">

                <section class="press__section">

                    <p class="press__text">Cleanfox est une start-up française qui lutte contre la pollution numérique grâce à un service gratuit pour nettoyer sa boîte mail.</p>

                </section>

                <section class="press__section">

                    <h3 class="press__title-paragraph">Nos Communiqués de Presse et Livres Blancs</h3>

                    <p class="press__text cfsp-text-link"><a class="cfsp-link" href="/documents/press/[CP] Le confinement, bénédiction ou malédiction pour l’environnement.pdf"
                                                             target="_blank">Le confinement:
                        bénédiction ou malédiction pour l'environement ?</a><span class="press__link-date"> (Avril 2020)</span></p>

                    <p class="press__text cfsp-text-link"><a class="cfsp-link" href="/documents/press/[CP] Cleanfox x WeForest - Comment planter des arbres sans bouger de son canapé _.docx"
                                                             target="_blank">Cleanfox x We
                        Forest:
                        Comment planter des arbres sans bouger de son canapé ?</a><span class="press__link-date"> (Mars 2020)</span></p>

                    <p class="press__text cfsp-text-link"><a class="cfsp-link" href="/documents/press/[CP]La Saint-Valentin, un jour noir pour nos boîtes mails et pour la planète_Cleanfox .docx"
                                                             target="_blank">La Saint-valentin,
                        un
                        jour noir pour nos boîtes mails et pour la planète.</a><span class="press__link-date"> (Février 2020)</span></p>

                    <p class="press__text cfsp-text-link"><a class="cfsp-link" href="/documents/press/Livre Blanc Pollution Cleanfox.pdf"
                                                             target="_blank">Livre Blanc: La
                        pollution numérique liée aux mails</a><span class="press__link-date"> (Mai 2019)</span></p>


                    <button v-if="!seeMore" class="press__btn-seee-more" @click="seeMoreClick">voir plus</button>

                    <div v-else>


                        <p class="cfsp-text cfsp-text-link"><a class="cfsp-link" href="/img/static/cp/reforestation.pdf" target="_blank">L’application Cleanfox s’engage pour la reforestation</a><span
                            class="press__link-date"> (Novembre 2017)</span></p>

                        <p class="cfsp-text cfsp-text-link"><a class="cfsp-link" href="/img/static/cp/reforestation.pdf" target="_blank">Earth Overshoot Day - Journée du dépassement 2017</a><span
                            class="press__link-date"> (Juillet 2017)</span></p>

                        <p class="cfsp-text cfsp-text-link"><a class="cfsp-link" href="/img/static/cp/Lancement.pdf" target="_blank">Lancement de Cleanfox - Nettoyez votre boîte mail, Protégez la
                            planète !</a><span class="press__link-date"> (Septembre 2017)</span></p>

                    </div>

                </section>

                <section class="press__section">

                    <h3 class="press__title-paragraph press__kit">Kit média</h3>

                    <a class="press__link" href="/img/logo/fox/blue-head-white.svg">Logo</a>

                    <a class="press__link" href="/img/logo/large/blue.svg">Bannière</a>

                    <a class="press__link" href="/documents/press/Dossier de Presse 2020.pdf">Dossier de Presse</a>

                </section>


                <section class="press__section">

                    <h3 class="press__title-paragraph">Contact Presse</h3>

                    <p class="press__text">Louis Balladur</p>
                    <p class="press__text">Communication Manager Balladur</p>
                    <a class="press__link" href="mailto:louis@foxintelligence.fr">louis@foxintelligence.fr</a>

                </section>

                <section class="press__section">

                    <h3 class="press__title-paragraph">Chiffres Clés</h3>

                    <p class="press__text press__text-bold">2016</p>
                    <p class="press__text">Cleanfox sort de son terrier</p>

                    <p class="press__text press__text-bold">3 millions</p>
                    <p class="press__text">Nombre d'utilisateurs</p>

                    <p class="press__text press__text-bold">160</p>
                    <p class="press__text">Nombre de pays où Foxy a fait son terrier</p>

                    <p class="press__text press__text-bold">4 milliards</p>
                    <p class="press__text">Nombre de mails supprimés</p>

                    <p class="press__text press__text-bold">40 000</p>
                    <p class="press__text">Nombre de tonnes de CO2 évitées par an grâce aux mails supprimés</p>

                </section>

            </div>


            <section class="press__section">

                <h3 class="press__title-paragraph">Ils parlent de nous</h3>

                <div class="press__bloc-media">

                    <a href="https://www.lemonde.fr/m-perso/article/2020/01/11/trois-applis-pour-dire-stop-en-2020_6025544_4497916.html"><img class="press__logo-media" src="/img/static/le-monde.png"></a>
                    <a href="http://www.leparisien.fr/environnement/nettoyer-sa-boite-mail-personne-ne-devrait-s-en-priver-30-10-2019-8183154.php"><img class="press__logo-media"
                                                                                                                                                        src="/img/static/Le_Parisien.png"></a>
                    <a href="https://france3-regions.francetvinfo.fr/centre-val-de-loire/coronavirus-12-choses-faire-quand-on-est-confine-soi-1801604.html"><img class="press__logo-media"
                                                                                                                                                                 src="/img/static/France_3.svg"></a>
                    <a href="http://www.konbini.com/fr/tendances-2/sauver-planete-commencez-deja-nettoyer-boite-mail/"><img class="press__logo-media" src="/img/static/konbini.png"></a>
                    <a href="[http://madame.lefigaro.fr/business/ecologie-digitale-rien-ne-sert-de-passer-au-zero-plastique-si-on-ne-trie-pas-ses-mails-061119-167810](http://madame.lefigaro.fr/business/ecologie-digitale-rien-ne-sert-de-passer-au-zero-plastique-si-on-ne-trie-pas-ses-mails-061119-167810)"><img
                        class="press__logo-media" src="/img/static/les-echos.png"></a>
                    <a href="http://madame.lefigaro.fr/business/ecologie-digitale-rien-ne-sert-de-passer-au-zero-plastique-si-on-ne-trie-pas-ses-mails-061119-167810"><img class="press__logo-media"
                                                                                                                                                                           src="/img/static/Le_Figaro.png"></a>

                </div>

            </section>


        </article>

        <article v-else class="page-static-text-container" v-html="html"></article>

        <footer-landing v-if="!isNativeUser"></footer-landing>

        <link href="/static/css/style.css" rel="stylesheet" type="text/css">

    </div>

</template>

<script>

import Vuex from 'vuex'

import I18n from '@/modules/i18n'
import UserFlow from '@/modules/userFlow'

import HeaderStatic from '@/components/headers/HeaderStatic'
import FooterLanding from '@/components/FooterLanding'

export default {

    name: 'press',

    components: {HeaderStatic, FooterLanding},

    watch: {

        lang: function () {
            this.loadContent()
        }

    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        },

        isFrench() {
            return this.lang === 'fr'
        }

    },

    data() {
        return {
            html: '',
            seeMore: false
        }
    },

    created() {
        UserFlow.setPage(this, 'press')
    },

    mounted() {

        this.loadContent()

    },

    methods: {

        loadContent() {

            this.$http.get(`/static/press/${I18n.get(this)}.html`)
                .then(response => {
                    this.html = response.data
                })
        },

        seeMoreClick() {
            this.seeMore = true
        }

    }
}
</script>

<style lang="scss" scoped>

.press {

    &__title {
        display: none;
    }

    &__title-paragraph {
        font-size: 22px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: -0.44px;
        margin: 24px 0 16px;
        color: $charcoal;
        @media screen and (min-width: $above-tablet-length) {
            margin-bottom: 48px;
        }
    }

    &__kit {
        display: flex;
        justify-content: space-around;
    }

    &__container {
        display: flex;
        flex-direction: column;
        margin-top: 35px;
        width: 100%;
        max-width: 644px;
    }

    &__bloc {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex: 1;
        margin: 0 8px;
    }

    &__text {
        font-size: 17px;
        line-height: 1.41;
        color: #3b3b54;
        text-align: left;
        font-weight: 500;
    }

    &__link {
        font-size: 17px;
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.34px;
        color: $blue;
        display: flex;
    }

    &__text-bold {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.25;
        letter-spacing: -.44px;
        color: #212121;
        margin-top: 8px;
    }

    &__link-date {
        font-size: 14px;
    }

    &__btn-seee-more {
        color: $blue;
        cursor: pointer;
        font-size: 17px;
        line-height: 1.41;
        font-weight: 500;
    }

    &__section {
        margin-top: 36px;
    }

    &__bloc-media {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    &__logo-media {
        width: 42px;
        object-fit: contain;
        @media screen and (min-width: $above-tablet-length) {
            width: auto;
            height: 48px;
        }
    }
}
</style>
